export default __webpack_public_path__ + "images/c0d1a5f15c41fe9d8c4e7f6ba9c0d182.svg";